import {parse} from 'date-fns';

export const getIsoLongDateFromIsoShortDate = (value?: string | null) => {
	return value == null
		? null
		: parse(value, 'yyyy-MM-dd', new Date()).toISOString();
};

export default getIsoLongDateFromIsoShortDate;
